import { FunctionComponent, useState } from 'react'
import { Swiper } from 'swiper/types'
import classNames from 'classnames'
import { RowType, Swimlane as SwimlaneProps } from './Swimlane.types'
import { BaseCarousel } from '../primitives/BaseCarousel/BaseCarousel'
import { UXComponentRenderer } from '../UXComponentRenderer/UXComponentRenderer'
import { SwimlaneNavigation } from './SwimlaneNavigation'
import { useMediaQuery } from 'src/hooks/useMediaQuery'
import { getSwiperProps } from './Swimlane.utils'
import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'
import 'swiper/scss/free-mode'
import 'swiper/scss/grid'
import './Swimlane.scss'

export const Swimlane: FunctionComponent<SwimlaneProps> = ({ attributes }) => {
  const {
    items,
    spaceBetween,
    pagination,
    justifyContent,
    rowType
  } = attributes
  const [swiperInstance, setSwiperInstance] = useState<Swiper | null>(null)
  const showAsGrid = useMediaQuery('(min-width: 1440px)')

  return (
    <div
      className={classNames('swimlane-ux-component', {
        'swimlane-ux-component--double': rowType === RowType.DOUBLE,
        'swimlane-ux-component--paginated': !!pagination
      })}
      style={
        {
          '--swiper-wrapper-justify-content': justifyContent
        } as React.CSSProperties
      }
      data-testid="swimlane">
      <BaseCarousel
        className="swimlane-ux-component__carousel"
        items={items.map((item, index) => (
          <UXComponentRenderer {...item} index={index} />
        ))}
        swiperProps={getSwiperProps(
          setSwiperInstance,
          spaceBetween,
          showAsGrid,
          rowType
        )}
      />

      {swiperInstance && (
        <SwimlaneNavigation
          swiper={swiperInstance}
          withCustomPagination={!!pagination}
        />
      )}
    </div>
  )
}
